// IMPORTS
import baseIcon from "./baseIcon"

/**
 * Exporting "default" so that the import doesn't have to be named in other components.
 * To create named and/or multiple exports, use: export cont compName = {}
 * Remember to import any reactive features from 'vue' if you need reactivity (e.g. computed, ref, reactive, etc.)
 */
export default {
    /* Name the component for easy reference */
    name: 'IconListChecks',

    /* Any imported component for this file needs to be listed here */
    components: {
        baseIcon
    },

    /* Declare any expected props here */
    props: {
        fill: {
            type: String,
            required: false,
            default: '#FFFFFF'
        }
    },

    /* All component logic goes here in setup(). Anything complex or verbose should be handled in an external file,
        using this as more of a "controller" for the component.
    */
    setup(props) {
        

        /* We need to return any variables/functions that we want to use in our template below. */
        return {
            props
        }
    },

    /* Define the template that will be displayed for this component (optional) */
    template: /*html*/`
        <div class="cfm_ec_icon cfm_ec_icon_checkmark">

            <base-icon
            :fill="props.fill"
            clipRule="evenodd"
            fillRule="evenodd"
            strokeLineJoin="round"
            strokeMiterLimit="2"
            d="m21 4c0-.478-.379-1-1-1h-16c-.62 0-1 .519-1 1v16c0 .621.52 1 1 1h16c.478 0 1-.379 1-1zm-16.5.5h15v15h-15zm13.5 10.75c0-.414-.336-.75-.75-.75h-4.5c-.414 0-.75.336-.75.75s.336.75.75.75h4.5c.414 0 .75-.336.75-.75zm-11.772-.537 1.25 1.114c.13.116.293.173.455.173.185 0 .37-.075.504-.222l2.116-2.313c.12-.131.179-.296.179-.459 0-.375-.303-.682-.684-.682-.185 0-.368.074-.504.221l-1.66 1.815-.746-.665c-.131-.116-.293-.173-.455-.173-.379 0-.683.307-.683.682 0 .188.077.374.228.509zm11.772-2.711c0-.414-.336-.75-.75-.75h-4.5c-.414 0-.75.336-.75.75s.336.75.75.75h4.5c.414 0 .75-.336.75-.75zm-11.772-1.613 1.25 1.114c.13.116.293.173.455.173.185 0 .37-.074.504-.221l2.116-2.313c.12-.131.179-.296.179-.46 0-.374-.303-.682-.684-.682-.185 0-.368.074-.504.221l-1.66 1.815-.746-.664c-.131-.116-.293-.173-.455-.173-.379 0-.683.306-.683.682 0 .187.077.374.228.509zm11.772-1.639c0-.414-.336-.75-.75-.75h-4.5c-.414 0-.75.336-.75.75s.336.75.75.75h4.5c.414 0 .75-.336.75-.75z"
            ></base-icon>

        </div>
    `,
}